import { useEffect, useMemo, useState } from "react";
import { Controller, set, useForm } from "react-hook-form";
import Input from "../../components/form-controls/Input";
import Select from "../../components/form-controls/Select";
import TextArea from "../../components/form-controls/TextArea";
import InvalidFeedback from "../../components/InvalidFeedback";
import Tags from "../../components/Tags";
import FormValidatorsPartial from "./FormValidatorsPartial";
import Swal from 'sweetalert2'
import FormMessagePartial from "./FormMessagePartial";
import Button from "../../components/form-controls/Button";
import { useTranslation } from "react-i18next";
import FormNotificationPartial from "./FormNotificationPartial";

function FormInteractiveNodePage({node, onDelete, chatbotInfo }) {

    const { t } = useTranslation();
    const [showPartial, setShowPartial] = useState(false);
    const [editIndex, setEditIndex] = useState(null);
    const [isLastNotification, setIsLastNotification] = useState(false);
    const attemptsBeforeCloseType = {
        attempts: 2,
        message: { es: '' },

        type: '',
        close: {
            category: '',
        },
        redirect_agent: [],
    }

    const interactiveTypeForm = {
        header: { es: '' },
        body: { es: '' },
        action: {
            button: { es: '' }, // Obligatorio si es lista
            sections: {
                title: { es: '' }, // Obligatorio si es lista
                rows: [{ es: '' }]
            }
        },
        footer: { es: '' },
    }

    const defaultValues = {
        _id: '',
        position: '',
        is_root: false,
        name: '',
        parent_nodes: [],
        keywords: [],
        type: 'INTERACTIVE',
        interactive: {
            type: '',
            text: { es: '' },
            list: interactiveTypeForm,
            buttons: interactiveTypeForm,

            validators: [],
            attempts_before_close: attemptsBeforeCloseType,
            triggers: []
        }
    }

    const { control, register, watch, getValues, setValue, reset, handleSubmit, formState: { errors, isValid, isSubmitting } } = useForm({
        mode: 'onChange',
        defaultValues
    });

    const validators = watch('interactive.validators');
    const interactiveType = watch('interactive.type');
    const notifications = watch('interactive.triggers');
    const formatTypeMessage = useMemo(() => {
        switch (interactiveType) {
            case 'TEXT':
                return 'Texto';
            case 'BUTTONS':
                return 'Respuestas rápidas';
            case 'LIST':
                return 'Lista';

            default:
                return interactiveType
        }
    }, [interactiveType])

    const previewMessage = useMemo(() => {
        switch (interactiveType) {
            case 'TEXT':
                return getValues('interactive.text.es');
            case 'BUTTONS':
                return getValues('interactive.buttons.body.es');
            case 'LIST':
                return getValues('interactive.list.body.es');

            default:
                return ''
        }
    }, [interactiveType])

    const messageStructure = useMemo(() => {
        const text = getValues('interactive.text')
        const list = getValues('interactive.list')
        const buttons = getValues('interactive.buttons')

        let params: any = {
            type: interactiveType,
        }

        switch (interactiveType) {
            case 'TEXT':
                params.text = text

                return params
            case 'BUTTONS':
                params.interactive = buttons

                return params
            case 'LIST':
                params.interactive = list

                return params

            default:
                return null
        }



    }, [interactiveType])

    const [showValidatorPartial, setshowValidatorPartial] = useState(false)
    const [showMessagePartial, setShowMessagePartial] = useState(false)
    const [showNotificationPartial, setShowNotificationPartial] = useState(false)
    const [validator, setValidator] = useState(null)
    const [notification, setNotification] = useState(null);
    const handleSaveValidation = (data) => {

        if (data) {
            if (Number.isInteger(data.internalID)) {
                let validatorsCopy = [...validators];
                validatorsCopy[data.internalID] = data

                setValue('interactive.validators', validatorsCopy)
            } else {
                setValue('interactive.validators', validators.concat(data))
            }
        }

        setshowValidatorPartial(false)
        setValidator(null)
    }

    const editValidator = (data) => {
        setValidator(data)
        setshowValidatorPartial(true)
    }

    const deleteValidator = async (index) => {
        const { isConfirmed } = await Swal.fire({
            title: 'Borrar validador',
            text: '¿Estás seguro de querer borrar este validador? Está acción no se puede deshacer',
            icon: 'warning',
            confirmButtonText: 'Continuar',
            cancelButtonText: 'Cancelar',
            showCancelButton: true
        })

        if(isConfirmed) {
            let validatorsCopy = [...validators];
            validatorsCopy.splice(index, 1)

            setValue('interactive.validators',  validatorsCopy)
        }
    }

    const getTypeValidator = (type) => {
        switch (type) {
            case 'NOT_MATCH_MENU':
                return 'Sin coincidencias'
            case 'EMAIL':
                return 'Correo electrónico'
            case 'NUMBER':
                return 'Número'
            case 'DATE':
                return 'Fecha'
            case 'URL':
                return 'URL'
            case 'PATTERN':
                return 'Expresión regular'
            case 'WEBHOOK':
                return 'WebHook'

            default:
                break;
        }
    }

    const handleSaveMessage = (data) => {

        if(data) {
            setValue('interactive.type', data.type)

            if(data.type === 'TEXT') {
                setValue('interactive.text', data.text)
            }
            if(data.type === 'BUTTONS') {
                setValue('interactive.buttons', data.interactive)
            }
            if(data.type === 'LIST') {
                setValue('interactive.list', data.interactive)
            }
        }

        setShowMessagePartial(false)
    }

    const editMessage = () => {
        setShowMessagePartial(true)
    }

    const addNotification = () => {
        const currentTrigger = getValues('interactive.triggers') || [];
        setNotification(null);
        setIsLastNotification(currentTrigger.length === 0 || currentTrigger.length === currentTrigger.length);
        setEditIndex(null);
        setShowNotificationPartial(true);
    }

    const handleSaveNotification = (data) => {
        if (data) {
            const currentTrigger = getValues('interactive.triggers') || [];
            if (editIndex !== null) {
                const updatedTrigger = [...currentTrigger];
                updatedTrigger[editIndex] = data;
                setValue('interactive.triggers', updatedTrigger);
            } else {
                const updatedTrigger = [...currentTrigger, data];
                setValue('interactive.triggers', updatedTrigger);
            }
            setEditIndex(null);
            setShowNotificationPartial(false);
        }
        setShowNotificationPartial(false)
    }

    const editNotification = (data,index) => {
        const currentTrigger = getValues('interactive.triggers') || [];
        const isLastNotification = index === currentTrigger.length - 1;
        setNotification(data);
        setIsLastNotification(isLastNotification);
        setEditIndex(index);
        setShowNotificationPartial(true);
    }

    const deleteNotification = async (index) => {
        const { isConfirmed } = await Swal.fire({
            title: 'Borrar Notificación',
            text: '¿Estás seguro de querer borrar esta notificación? Está acción no se puede deshacer',
            icon: 'warning',
            confirmButtonText: 'Continuar',
            cancelButtonText: 'Cancelar',
            showCancelButton: true
        })

        if (isConfirmed) {
            let notificationCopy = [...notifications];
            notificationCopy.splice(index, 1)

            setValue('interactive.triggers', notificationCopy);
        }
    }

    const isValidNotification = useMemo(() => {
        if (showPartial) {
            return notifications && notifications.length > 0;
        }
        return true;
    }, [showPartial, notifications]);
    
    const handleCheckboxChange = (event) => {
        setShowPartial(event.target.checked);
    };

    const submit = async(data: typeof defaultValues) => {
        data.position = node.position;

        if(data.interactive.type === 'TEXT') {
            delete data.interactive.buttons
            delete data.interactive.list
        }
        if(data.interactive.type === 'LIST') {
            delete data.interactive.buttons
            delete data.interactive.text
        }
        if(data.interactive.type === 'BUTTONS') {
            delete data.interactive.list
            delete data.interactive.text
        }

        if(data.interactive.attempts_before_close.type === 'CLOSE') {
            delete data.interactive.attempts_before_close.redirect_agent
        }
        if(data.interactive.attempts_before_close.type === 'REDIRECT_AGENT') {
            delete data.interactive.attempts_before_close.close
        }

        if (showPartial) {
            data.interactive.triggers = notifications;
        } else {
            delete data.interactive.triggers;
        }
        await node.data.handleSaveNode({ nodeID: node.id, data, chatbotInfo });
    }

    const initialValues = useMemo(() => {
        return node.data.interactive ? node.data.interactive.attempts_before_close.redirect_agent.map(v => ({ label: v, value: v })): []
    }, [node.data])

    const isLastNotificationClosed = useMemo(() => {
        return notifications?.length > 0 && notifications[notifications?.length - 1]?.close;
    }, [notifications]);

    useEffect(() => {
        reset(Object.assign(defaultValues, node.data));
    }, [node.data]);

    useEffect(() => {
        if (node.data?.interactive?.triggers?.length > 0) {
            setShowPartial(true);
        } else {
            setShowPartial(false);
        }
    }, [node.data._id]);
    
    useEffect(() => {
        if (!showPartial) {
            setValue("interactive.triggers", []);
        } else if (node.data?.interactive?.triggers) {
            setValue("interactive.triggers", node.data.interactive.triggers);
        }
    }, [showPartial]);

    useEffect(() => {
        !showPartial && setValue('interactive.triggers', []);
    }, [showPartial])

    return (
        <>
            {
                !showValidatorPartial && !showMessagePartial && !showNotificationPartial && (
                    <div className="push-view">
                        <div className="card-header bg-soft-info-alternative">
                            <h3 className="card-header-title">{t("platform.chatbot.interactive-node.config-title")}</h3>
                            <p className="m-0"><small className="text-muted">{t("platform.chatbot.interactive-node.interactive")}</small></p>
                            { getValues('_id') && <p className="m-0"><small className="text-muted">Nodo id: {getValues('_id')}</small></p> }
                        </div>
                        <div className="card-body">
                            <div className="mb-3">
                                <Input label={t("platform.chatbot.interactive-node.name")} errors={errors.name} {...register('name', { required: true })} />
                            </div>

                            {
                                interactiveType !== '' && (
                                    <div className="card my-3" >
                                        <div className="card-body p-3">
                                            <span className="card-subtitle">{formatTypeMessage}</span>
                                            <p className="card-text nowrap-lines-1 m-0">{previewMessage}</p>
                                        </div>
                                    </div>
                                )
                            }


                            <div className="d-grid gap-2 mb-3">
                                <button type="button" className="btn btn-secondary btn-sm" onClick={() => editMessage()} >{t("platform.chatbot.interactive-node.config-btn")}</button>
                            </div>


                            <div className="form-node-title d-flex align-items-center cursor-pointer" data-bs-toggle="collapse" data-bs-target="#dropdownUserResponse" >
                                <h5>{t("platform.chatbot.interactive-node.user-feedback")}</h5>
                                <i className="bi-chevron-down ms-auto me-2"></i>
                            </div>

                            <div id="dropdownUserResponse" className="collapse show" >
                                {
                                    validators.map((v: any, index: number) => (
                                        <div className="card my-3" key={index}>
                                            <div className="card-body">
                                                <span className="card-subtitle">{getTypeValidator(v.type)}</span>
                                                <p className="card-text nowrap-lines-1 mb-2">{v.message.es}</p>
                                                <p>
                                                    <li className="list-inline-item d-inline-flex align-items-center">
                                                        {
                                                            !v.show_messages_again && <><span className="legend-indicator bg-danger"></span>No repetir mensajes</>
                                                        }
                                                        {
                                                            v.show_messages_again && <><span className="legend-indicator bg-success-alternative"></span>Volver a repetir mensajes</>
                                                        }

                                                    </li>
                                                </p>
                                                <span className="card-link cursor-pointer text-success " onClick={() => editValidator({...v, internalID: index})}>Editar</span>
                                                <span className="card-link cursor-pointer text-danger" onClick={() => deleteValidator(index)}>Borrar</span>
                                            </div>
                                        </div>
                                    ))
                                }
                                <div className="d-grid gap-2 my-3">
                                    <button type="button" className="btn btn-secondary btn-sm" onClick={() => setshowValidatorPartial(true)} >+ {t("platform.chatbot.interactive-node.add-btn")}</button>
                                </div>
                            </div>

                            <div>
                                <div className="form-node-title d-flex align-items-center cursor-pointer" data-bs-toggle="collapse" data-bs-target="#dropdownValidationTries">
                                    <h5>{t("platform.chatbot.interactive-node.validation")}</h5>
                                    <i className="bi-chevron-down ms-auto me-2"></i>
                                </div>

                                <div id="dropdownValidationTries" className="collapse show">
                                    <div className="my-3">
                                        <Input label={t("platform.chatbot.interactive-node.attempts")} type='number' errors={errors.interactive?.attempts_before_close?.attempts} {...register('interactive.attempts_before_close.attempts', { required: true })} />
                                    </div>

                                    <div className="mb-3">
                                        <TextArea
                                            label={t("platform.chatbot.interactive-node.message")}
                                            errors={errors.interactive?.attempts_before_close?.message?.['es']}
                                            value={watch('interactive.attempts_before_close.message.es').length}
                                            counter={1024}
                                            {...register('interactive.attempts_before_close.message.es', { required: true, maxLength: { value: 1024, message: '1024' } })} />
                                    </div>

                                    <div className="mb-3">
                                        <Select
                                            label={t("platform.chatbot.interactive-node.actions")}
                                            data={[{ value: 'CLOSE', text: 'Cerrar ticket' }, { value: 'REDIRECT_AGENT', text: 'Redireccionar a un agente' }]}
                                            errors={errors.interactive?.attempts_before_close?.type}
                                            {...register('interactive.attempts_before_close.type', { required: true })}
                                        />
                                    </div>

                                    {
                                        watch('interactive.attempts_before_close.type') === 'CLOSE' && (
                                            <div className="mb-3">
                                                <Input label={t("platform.chatbot.interactive-node.close-category")} errors={errors.interactive?.attempts_before_close?.close?.category} {...register('interactive.attempts_before_close.close.category', { required: true })} />
                                            </div>
                                        )
                                    }

                                    {
                                        watch('interactive.attempts_before_close.type') === 'REDIRECT_AGENT' && (

                                            <div className="mb-3">
                                                <label className="form-label" >Agentes *</label>
                                                <Controller
                                                    control={control}
                                                    name='interactive.attempts_before_close.redirect_agent'
                                                    render={({
                                                        field: { onChange, value },
                                                        fieldState: { error },
                                                    }) => {

                                                        return (
                                                            <Tags
                                                                isInvalid={!!error}
                                                                onChange={(values: any) => onChange(values)}
                                                                initialValue={ initialValues }
                                                            />
                                                        )
                                                    }}
                                                />
                                                <InvalidFeedback error={errors.interactive?.attempts_before_close?.redirect_agent} />
                                            </div>
                                        )
                                    }
                                </div>
                            </div>


                            <div className="form-node-title d-flex align-items-center cursor-pointer form-switch">
                                <h5>{t("platform.chatbot.interactive-node.notification-inactivity")}</h5>
                                <input type="checkbox" className="form-check-input ms-auto" checked={showPartial} onChange={handleCheckboxChange} />
                            </div>
                            {
                                showPartial &&
                                <>
                                    {
                                        (notifications !== undefined) && (
                                            notifications.map((v: any, index: number) => (
                                                <div className="card my-3" key={index}>
                                                    <div className="card-body">
                                                        <span className="card-subtitle">{(`NOTIFICACIÓN NUM. ${index + 1}`)}</span>
                                                        <h5 className="text-muted">Mensaje a enviar...</h5>
                                                        <p className="card-text nowrap-lines-1 m-0">{v.text.es}</p>
                                                        <div className={`${(v.webhook || v.close) ? '' : 'd-none'}`}>
                                                            <li className="list-inline-item d-inline-flex align-items-start flex-column">
                                                                {
                                                                    v.webhook && (
                                                                        <div>
                                                                            <span className="legend-indicator bg-success-alternative"></span>Webhook
                                                                        </div>
                                                                    )
                                                                }
                                                                {
                                                                    v.close && (
                                                                        <div>
                                                                            <span className="legend-indicator bg-danger"></span>Cerrar ticket
                                                                        </div>
                                                                    )
                                                                }
                                                            </li>
                                                        </div>
                                                        <span className="card-link cursor-pointer text-success " onClick={() => editNotification({ ...v }, index)}>Editar</span>
                                                        <span className="card-link cursor-pointer text-danger" onClick={() => deleteNotification(index)}>Borrar</span>
                                                    </div>
                                                </div>
                                            ))
                                    )
                                    }
                                    <div>
                                        <div className="d-grid gap-2 my-3">
                                            <button type="button" className="btn btn-secondary btn-sm" onClick={() => addNotification()} disabled={isLastNotificationClosed}>+ {t('platform.chatbot.interactive-node.add-notification')}</button>
                                        </div>
                                    </div>
                                </>
                            }

                            <div className="d-grid gap-2 my-3 ">
                                <Button
                                    type="submit"
                                    className="btn btn-primary"
                                    disabled={!isValid || !isValidNotification}
                                    isLoading={isSubmitting}
                                    onClick={handleSubmit(submit)}
                                >
                                    {t('btn-save')}
                                </Button>
                            </div>

                            {
                                getValues('_id') && (
                                    <div className="d-grid gap-2 my-3 ">
                                        <Button type="submit" className="btn btn-ghost-danger"  onClick={() => onDelete(getValues('_id')) }>{t("platform.chatbot.delete-node")}</Button>
                                    </div>
                                )
                            }

                        </div>
                    </div>
                )
            }

            {
                showValidatorPartial &&
                <FormValidatorsPartial
                    data={validator}
                    onClose={ (validation) => handleSaveValidation(validation) }
                />
            }

            {
                showMessagePartial &&
                <FormMessagePartial
                    data={messageStructure}
                    onClose={ (message) => handleSaveMessage(message) }
                />
            }
            {
                showNotificationPartial &&
                <FormNotificationPartial
                    data={notification}
                    onClose={(notification) => handleSaveNotification(notification)}
                    isLastNotification={isLastNotification}
                />
            }

        </>
    )
}
export default FormInteractiveNodePage